import config from './config';
import PagesConfig from '../pages/config';
import schema from "../pages/schema"
import model from "@/services/resources/model";
import Repository from "./repository";

export default () => {
    return {
        config,
        schema,
        repository: Repository.make(model(PagesConfig), schema)
    }
};
